import {rgElement} from '../rgElement/rg-element.js'
export class rgSelectcontent extends rgElement {

    $element = null;
    $hiddenelement = null;
    $listelement = null;
    #trclass = null;
    #rootnode = null;
    #fetching = false;
    #timer = null;
    #oldValue = {
        value: '',
        displayText: ''
    };
    #start = 0;
    #limit = 10;

    constructor() {
        super();
    }

    connectedCallback() {
        this.setUpElement();
        this.attachShadow({mode: 'open'});
        this.style.display = 'block';

        this.#trclass = this.dataset.trtype;
        this.#rootnode = this.dataset.root;
        /*if (this.form && this.dataset.name) {
            this.$element = this.form.querySelector('*[name="' + this.dataset.name + '"]');
        } else if (this.dataset.name) {
            this.$element = document.querySelector('*[name="' + this.dataset.name + '"]');
        }*/
        if (!this.$element) {
            let input = document.createElement('input');
            input.setAttribute('type', 'text');
            input.setAttribute('value', this.dataset.displayvalue);
            input.setAttribute('name', 'livesearch' + this.dataset.name);
            this.$element = this.shadowRoot.host.parentElement.insertBefore(input, this.shadowRoot.host);
        }
        const linkElem = document.createElement('link');
        linkElem.setAttribute('rel', 'stylesheet');
        linkElem.setAttribute('href', this.rootpath + '/css/rg-selectcontent.css');
        let hiddeninput = document.createElement('input');
        hiddeninput.setAttribute('type', 'hidden');
        hiddeninput.setAttribute('name', this.dataset.name);
        hiddeninput.setAttribute('value', this.dataset.value);
        this.$hiddenelement = this.shadowRoot.host.parentElement.insertBefore(hiddeninput, this.shadowRoot.host);

        const adoptedCSSTag = document.createElement('style');
        adoptedCSSTag.innerHTML = this.copyStyles('.selectcontent');
        //append them
        this.shadowRoot.append(linkElem, adoptedCSSTag);
        this.$element.addEventListener('keydown', (ev) => {
            if([
                'Enter',
                'NumpadEnter',
                'ArrowUp',
                'ArrowDown'
            ].include(ev.code)) {
                ev.preventDefault();
                return false;
            }
        });
        this.$element.addEventListener('keyup', this.#handleKey.bind(this));
        this.$element.addEventListener('click', function (ev) {
            if (this.$listelement && this.$listelement.hasChildNodes()) {
                this.$listelement.style.display = 'block';
            }
        }.bind(this));
        this.#oldValue.displayText = this.$element.value;
        this.#oldValue.value = this.$hiddenelement.value;
        this.$element.addEventListener('blur', function (ev) {
            if (this.$listelement) {
                this.$listelement.style.display = 'none';
            }
            if (this.$hiddenelement.value === '') {
                this.$element.value = this.#oldValue.displayText;
                this.$hiddenelement.value = this.#oldValue.value;
            }
        }.bind(this));
        if (typeof recon === 'object') {
            recon.on('categorySelect', function (config) {
                if (config.contentroot && config.contentroot[this.$hiddenelement.name]) {
                    //Evtl. per attribute data-root???
                    this.#rootnode = config.contentroot[this.$hiddenelement.name];
                    /*const event = new KeyboardEvent('keyup', {
                        bubbles: true,
                        cancelable: true
                    });
                    this.#showLoadingResults();
                    this.$element.dispatchEvent(event);*/
                }
            }.bind(this));
        }

        this.setupComplete();
    }

    static get observedAttributes() {
        return ['data-value', 'data-displayvalue', 'data-trtype'];
    }


    attributeChangedCallback(name, oldValue, newValue) {
        if (this.$element) {
            debugger;
        }
    }

    #getUrl() {
        let newValue = this.$element.value.trim(),
            nodeFilter = this.#rootnode ? '&r=' + this.#rootnode : '',
            match = newValue.match(/(^\d+)\s+/);
        if (match) {
            newValue = match[1];
        }
        return `livesearch.js?_func=fndCnt&trcl=${this.#trclass}&viewmode=list&_trid=-1&start=${this.#start}&limit=${this.#limit}&filter=${newValue}${nodeFilter}`;
    }


    #handleKey(ev) {
        switch (ev.key) {
            case 'Escape':
                if (this.$listelement) {
                    this.$listelement.style.display = 'none';
                }
                break;
            case 'Enter':
            case 'NumpadEnter':
                if (this.$listelement && this.$listelement.style.display === 'block') {
                    let activeListElement = this.$listelement.querySelector('.active');
                    if (activeListElement) {
                        let event = new MouseEvent('pointerdown', {
                            bubbles: true,
                            cancelable: true
                        });
                        activeListElement.dispatchEvent(event);
                    }
                }
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                break;
            case 'ArrowDown':
            case 'ArrowUp':
                if (this.$listelement) {
                    this.$listelement.style.display = 'block';
                    let activeListElement = this.$listelement.querySelector('.active'),
                        nextElementToSelect,
                        event = new MouseEvent('mouseover', {
                            bubbles: true,
                            cancelable: true
                        });
                    if (activeListElement) {
                        activeListElement.classList.remove('active');
                        if (ev.key === 'ArrowDown') {
                            nextElementToSelect = activeListElement.nextElementSibling || activeListElement;
                        } else {
                            nextElementToSelect = activeListElement.previousElementSibling || activeListElement;
                        }
                        nextElementToSelect.dispatchEvent(event);
                    } else {
                        this.$listelement.firstChild.dispatchEvent(event);
                    }
                }
                break;
            default:
                this.$hiddenelement.value = '';
                this.#start = 0;
                let newValue = this.$element.value.trim();
                if (!this.#fetching && newValue.length >= 3) {
                    if (this.#timer) {
                        clearTimeout(this.#timer);
                    }
                    this.#timer = setTimeout(function () {
                        this.#fetch();
                    }.bind(this), 500);
                }
                break;
        }
    }

    #fetch() {
        this.#fetching = true;
        this.#showLoadingResults();
        fetch(this.#getUrl(), {
            method: 'GET',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            redirect: 'follow'
        }).then((response) => response.json()).then(function (data) {
            this.#fetching = false;
            this.#showResluts(data);
        }.bind(this)).catch( (ex) => {
            console.error(ex);
        } )
    }

    #createListElement() {
        if (!this.$listelement) {
            this.$listelement = document.createElement('div');
            this.$listelement.classList.add('rg-selectcontent');
            this.shadowRoot.append(this.$listelement);
            let bounds = this.$element.getBoundingClientRect();
            this.$listelement.style.minWidth = bounds.width + 'px';
        }
    }

    #showLoadingResults() {
        this.#clearResults();
        let loadingDiv = document.createElement('div');
        loadingDiv.classList.add('rg-selectcontent__loading');
        loadingDiv.innerHTML = '<div></div><div></div><div></div><div></div>';
        this.$listelement.append(loadingDiv);
    }

    #clearResults() {
        this.#createListElement();
        let childNode = this.$listelement.firstChild;
        while (childNode) {
            this.$listelement.removeChild(childNode);
            childNode = this.$listelement.firstChild
        }
    }

    #showResluts(data) {
        this.#createListElement();
        this.#clearResults();
        for (const [key, value] of Object.entries(data.contents)) {
            let entry = document.createElement('div');
            entry.classList.add('rg-selectcontent__listelement');
            entry.innerHTML = value.title;
            entry.setAttribute('data-id', value.id);
            entry.setAttribute('data-title', value.title);
            this.$listelement.append(entry);
            entry.addEventListener('pointerdown', function (ev) {
                this.$hiddenelement.value = ev.target.dataset.id;
                this.$element.value = ev.target.dataset.title;
                this.#oldValue.value = ev.target.dataset.id;
                this.#oldValue.displayText = ev.target.dataset.title;
                this.$listelement.style.display = 'none';
            }.bind(this));
            entry.addEventListener('mouseover', function (ev) {
                this.classList.add('active');
            });
            entry.addEventListener('mouseout', function (ev) {
                this.classList.remove('active');
            });
        }
        let totalCount = Number(data.totalCount);
        if (totalCount === 0) {
            this.$listelement.style.display = 'none';
            return;
        }
        if (totalCount > 10) {
            let pager = document.createElement('div'),
                arrowLeft = document.createElement('div'),
                arrowRight = document.createElement('div');
            arrowLeft.innerHTML = '&lt;&lt;';
            arrowRight.innerHTML = '&gt;&gt;';
            if (this.#start === 0) {
                arrowLeft.classList.add('hidden');
            }
            if (this.#start + this.#limit >= totalCount) {
                arrowRight.classList.add('hidden');
            }
            arrowLeft.addEventListener('pointerdown', function (ev) {
                this.#start -= this.#limit;
                if (this.#start < 0) {
                    this.#start = 0;
                }
                this.#fetch();
            }.bind(this));
            arrowRight.addEventListener('pointerdown', function (ev) {
                this.#start += this.#limit;
                this.#fetch();
            }.bind(this));
            pager.append(arrowLeft, arrowRight);
            pager.classList.add('rg-selectcontent__pager')
            this.$listelement.append(pager);
        }
        this.$listelement.style.display = 'block';
    }
}